(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero"] && !Shopify.designMode) return;
  try {
    
  class CustomHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.custom-hero__slide'));
      if (this.slides.length < 2) return;

      this.track = this.querySelector('.custom-hero__slides');
      this.dots = Array.from(this.querySelectorAll('.custom-hero__dot'));
      this.index = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );

      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.autoplayEnabled =
        this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayCancelled = false;

      this.querySelector('.custom-hero__arrow--prev').addEventListener('click', () => this.step(-1));
      this.querySelector('.custom-hero__arrow--next').addEventListener('click', () => this.step(1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.cancelAutoplay();
          this.select(Number(dot.dataset.index));
        });
      });

      this.addEventListener('touchstart', this.onTouchStart, { passive: true });
      this.addEventListener('touchend', this.onTouchEnd, { passive: true });

      // ホバー・フォーカス中は自動送りを止める（読んでいる途中で切り替わらないように）
      this.addEventListener('mouseenter', this.pauseAutoplay);
      this.addEventListener('mouseleave', this.startAutoplay);
      this.addEventListener('focusin', this.pauseAutoplay);
      this.addEventListener('focusout', this.startAutoplay);

      // テーマエディタでスライドを選択したらそのスライドを表示する
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.startAutoplay();
    }

    disconnectedCallback() {
      this.pauseAutoplay();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    select(next) {
      const total = this.slides.length;
      const index = ((next % total) + total) % total;
      if (index === this.index) return;

      this.slides[this.index].classList.remove('is-active');
      this.slides[index].classList.add('is-active');

      if (this.dots.length) {
        this.dots[this.index].removeAttribute('aria-current');
        this.dots[index].setAttribute('aria-current', 'true');
      }

      this.index = index;
    }

    step(direction) {
      this.cancelAutoplay();
      this.select(this.index + direction);
    }

    startAutoplay = () => {
      if (!this.autoplayEnabled || this.autoplayCancelled) return;
      this.pauseAutoplay();
      this.timer = setInterval(() => this.select(this.index + 1), this.speed);
      // 自動で切り替わっている間は読み上げを抑制する（Dawn と同じ考え方）
      this.track.setAttribute('aria-live', 'off');
    };

    pauseAutoplay = () => {
      clearInterval(this.timer);
      this.track.setAttribute('aria-live', 'polite');
    };

    // 手動操作されたら自動送りは再開しない
    cancelAutoplay() {
      this.autoplayCancelled = true;
      this.pauseAutoplay();
    }

    onTouchStart = (event) => {
      this.touchStartX = event.changedTouches[0].screenX;
    };

    onTouchEnd = (event) => {
      if (this.touchStartX == null) return;
      const delta = event.changedTouches[0].screenX - this.touchStartX;
      this.touchStartX = null;
      if (Math.abs(delta) < 40) return;
      this.step(delta < 0 ? 1 : -1);
    };

    onBlockSelect = (event) => {
      const slide = event.target.closest('.custom-hero__slide');
      if (!slide || !this.contains(slide)) return;
      this.pauseAutoplay();
      this.select(Number(slide.dataset.index));
    };

    onBlockDeselect = (event) => {
      if (!this.contains(event.target)) return;
      this.startAutoplay();
    };
  }

  if (!customElements.get('custom-hero')) {
    customElements.define('custom-hero', CustomHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
